<div class="tab-list">
  <div class="tab"
    *ngFor="let tab of tabs"
    [ngClass]="{'tab--active': tab.active}"
    (click)="onSetTab(tab)">
    <span class="tab__header">{{tab.header}}</span>
  </div>
</div>
<ng-content></ng-content>